import messages from "./messages";
import configurations from "./configurations";

const translations = {
  ...messages,
  ...configurations,
  "Add area": "اضافة منطقة",
  "Areas & Rates": "المناطق و التسعيرات",
  "Delivery ": "التوصيل",
  Province: "المحافظة",
  "Delivery charge (numbers)": "سعر التوصيل (رقم)",
  "Delivery cost": "تكلفة التوصيل",
  "Select a province": "اختر المحافظة",
  Role: "الصلاحيات",
  Default: "الافتراضي",
  "Pin area (anywhere in the area for reporting)": "ضع العنوان",
  "New Area": "منطقة جديدة",
  "New Province": "محافظة جديدة",
  "Add province": "إضافة محافظة",

  "Select all?": "تحديد الكل؟",
  "areas selected out of": "مناطق محددة من اصل",
  "Set charge to": "تغيير السعر الى",
  "Set price for all": "حدد السعر",
  "Leaving the field empty will keep the prices as is":
    "ترك السعر بدون تحديد لن يؤثر على الاسعار الحالية",
  "Cancel selection?": "الغاء التحديد؟",
  "To use this feature,": "لاستخدام هذه الميزة، قم بإضافة",
  "and make sure to mark your location on the map provided":
    "و تأكد من تحديد موقع الفرع على الخريطة",
  "DHL compatible": "متوافق مع DHL",
  "Are you sure you want to delete this area?":
    "هل انت متاكد من حذف هذه المنطقة؟",
  "Are you sure you want to delete all selected areas? You can't undo this action":
    "هل انت متأكد من حذف جميع المناطق المحددة؟ لا يمكنك الرجوع",

  "DHL incompatible": "غير متوافق مع DHL",
  "By Date and Time": "حسب تاريخ و وقت التوصيل",
  Provinces: "المحافظات",
  Continent: "القارة",
  "Add countries": "اضافة دول",
  "Search for a country": "البحث عن دولة",
  International: "عالمي",
  Local: "محلي",
  GCC: "دول الخليج",
  "Edit boundaries": "تعديل النطاق",
  "Draw or edit the boundaries of the area": "ارسم او عدّل نطاق المنطقة",
  Actions: "إجراءات",
  "Show delivery coverage": "عرض تغطية التوصيل",
  "Delivery coverage": "تغطية التوصيل",
  "Selected area": "المنطقة المحددة",
  "Click a polygon to select an area": "اضغط على المضلع لتحديد المنطقة",
  "Enable this area?": "تفعيل هذه المنطقة؟",
  "Disable this area?": "تعطيل هذه المنطقة؟",
  "No areas with polygons yet": "لا توجد مناطق ذات مضلعات بعد",
  Import: "استيراد",
  Export: "تصدير",
  "Import KML/KMZ": "استيراد KML/KMZ",
  "Export KML": "تصدير KML",
  "English name": "الاسم الإنجليزي",
  "Arabic name": "الاسم العربي",
  "File validated successfully": "تم التحقق من الملف بنجاح",
  "Please upload a KML or KMZ file": "يرجى رفع ملف KML أو KMZ",
  "Please upload a valid KML or KMZ file.": "يرجى رفع ملف KML أو KMZ صالح.",
  "The uploaded file is empty.": "الملف المرفوع فارغ.",
  "The uploaded KMZ file does not contain a KML document.":
    "ملف KMZ المرفوع لا يحتوي على مستند KML.",
  "The uploaded KMZ file could not be opened.":
    "تعذر فتح ملف KMZ المرفوع.",
  "The uploaded file is not a valid KML/KMZ document.":
    "الملف المرفوع ليس مستند KML/KMZ صالحًا.",
  "No polygon areas were found in the uploaded file.":
    "لم يتم العثور على مناطق مضلعة داخل الملف المرفوع.",
  "Missing import data.": "بيانات الاستيراد غير مكتملة.",
  "The import preview expired. Please upload the file again.":
    "انتهت صلاحية معاينة الاستيراد. يرجى رفع الملف مرة أخرى.",
  "Please keep at least one area selected for import.":
    "يرجى الإبقاء على منطقة واحدة على الأقل محددة للاستيراد.",
  "Missing export data.": "بيانات التصدير غير مكتملة.",
  "One or more imported areas are invalid.":
    "واحدة أو أكثر من المناطق المستوردة غير صالحة.",
  "One or more selected export areas are invalid.":
    "واحدة أو أكثر من المناطق المحددة للتصدير غير صالحة.",
  "Duplicate imported areas were submitted.":
    "تم إرسال مناطق مستوردة مكررة.",
  "Every imported area must include English and Arabic names.":
    "يجب أن تحتوي كل منطقة مستوردة على اسم إنجليزي واسم عربي.",
  "Every imported area must include a valid country and province.":
    "يجب أن تحتوي كل منطقة مستوردة على دولة ومحافظة صالحين.",
  "The selected province must belong to the selected country.":
    "يجب أن تنتمي المحافظة المحددة إلى الدولة المحددة.",
  "Every imported area must include a valid delivery charge.":
    "يجب أن تحتوي كل منطقة مستوردة على سعر توصيل صالح.",
  "Delivery charge cannot be negative.":
    "لا يمكن أن يكون سعر التوصيل رقمًا سالبًا.",
  "Please select a country first": "يرجى اختيار الدولة أولًا",
  "Please select a province first": "يرجى اختيار المحافظة أولًا",
  "Please enter a valid delivery charge": "يرجى إدخال سعر توصيل صالح",
  "Please select at least one area to export.":
    "يرجى تحديد منطقة واحدة على الأقل للتصدير.",
  "Please complete all imported area details":
    "يرجى استكمال جميع بيانات المناطق المستوردة",
  "There are no areas with shapes to export.":
    "لا توجد مناطق تحتوي على نطاقات قابلة للتصدير.",
  "areas imported successfully": "منطقة تم استيرادها بنجاح",
  "Upload one KML or KMZ file, review the detected areas, then complete the missing Arabic names, country, province, and delivery charge before importing.":
    "ارفع ملف KML أو KMZ واحدًا، ثم راجع المناطق المكتشفة وأكمل الاسم العربي والدولة والمحافظة وسعر التوصيل قبل بدء الاستيراد.",
  "Select the areas you want to include in the exported KML file.":
    "حدد المناطق التي تريد تضمينها في ملف KML المُصدَّر.",
  "Click or drag a KML/KMZ file to this area":
    "اضغط أو اسحب ملف KML/KMZ إلى هذه المنطقة",
  "Only one file can be uploaded at a time":
    "يمكن رفع ملف واحد فقط في كل مرة",
  "Selected file": "الملف المحدد",
  "Areas in file": "عدد المناطق في الملف",
  "Preview map": "معاينة الخريطة",
  "Show areas": "عرض المناطق",
  "Hide areas": "إخفاء المناطق",
  "Clear file": "إزالة الملف",
  "Bulk country": "الدولة لجميع المناطق",
  "Apply country to all": "تطبيق الدولة على الجميع",
  "Bulk province": "المحافظة لجميع المناطق",
  "Apply province to all": "تطبيق المحافظة على الجميع",
  "Bulk delivery charge": "سعر التوصيل لجميع المناطق",
  "Apply charge to all": "تطبيق السعر على الجميع",
};

export default translations;
